import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { FlagQualifier } from "../qualifiers/flag/FlagQualifier.js";
import { Qualifier } from "./qualifier/Qualifier.js";
import { mapToSortedArray } from "./utils/dataStructureUtils.js";
import { ActionModel } from "./models/ActionModel.js";
/**
 * @summary SDK
 * @memberOf SDK
 * @description Defines the category of transformation to perform.
 */

var Action = /*#__PURE__*/function (_ActionModel) {
  _inherits(Action, _ActionModel);

  var _super = _createSuper(Action);

  function Action() {
    var _this;

    _classCallCheck(this, Action);

    _this = _super.apply(this, arguments); // We're using map, to overwrite existing keys. for example:
    // addParam(w_100).addQualifier(w_200) should result in w_200. and not w_100,w_200

    _this.qualifiers = new Map(); // Unlike regular qualifiers, there can be multiple flags in each url component /fl_1,fl_2/
    // If the falgs are added to the qualifiers map, only a single flag could exist in a component (it's a map)
    // So flags are stored separately until the very end because of that reason

    _this.flags = [];
    _this.delimiter = ','; // {qualifier}{delimiter}{qualifier} for example: `${'w_100'}${','}${'c_fill'}`

    _this.actionTag = ''; // A custom name tag to identify this action in the future

    return _this;
  }

  _createClass(Action, [{
    key: "prepareQualifiers",
    value: function prepareQualifiers() {}
    /**
     * @description Returns the custom name tag that was given to this action
     * @return {string}
     */

  }, {
    key: "getActionTag",
    value: function getActionTag() {
      return this.actionTag;
    }
    /**
     * @description Sets the custom name tag for this action
     * @return {this}
     */

  }, {
    key: "setActionTag",
    value: function setActionTag(tag) {
      this.actionTag = tag;
      return this;
    }
    /**
     * @description Calls toString() on all child qualifiers (implicitly by using .join()).
     * @return {string}
     */

  }, {
    key: "toString",
    value: function toString() {
      this.prepareQualifiers();
      return mapToSortedArray(this.qualifiers, this.flags).join(this.delimiter);
    }
    /**
     * @description Adds the parameter to the action.
     * @param {SDK.Qualifier} qualifier
     * @return {this}
     */

  }, {
    key: "addQualifier",
    value: function addQualifier(qualifier) {
      // if string, find the key and value
      if (typeof qualifier === 'string') {
        var _qualifier$toLowerCas = qualifier.toLowerCase().split('_'),
            _qualifier$toLowerCas2 = _slicedToArray(_qualifier$toLowerCas, 2),
            key = _qualifier$toLowerCas2[0],
            value = _qualifier$toLowerCas2[1];

        if (key === 'fl') {
          // if string qualifier is a flag, store it in the flags arrays
          this.flags.push(new FlagQualifier(value));
        } else {
          // if the string qualifier is not a flag, create a new qualifier from it
          this.qualifiers.set(key, new Qualifier(key, value));
        }
      } else {
        // if a qualifier object, insert to the qualifiers map
        this.qualifiers.set(qualifier.key, qualifier);
      }

      return this;
    }
    /**
     * @description Adds a flag to the current action.
     * @param {Qualifiers.Flag} flag
     * @return {this}
     */

  }, {
    key: "addFlag",
    value: function addFlag(flag) {
      if (typeof flag === 'string') {
        this.flags.push(new FlagQualifier(flag));
      } else {
        if (flag instanceof FlagQualifier) {
          this.flags.push(flag);
        }
      }

      return this;
    }
  }, {
    key: "addValueToQualifier",
    value: function addValueToQualifier(qualifierKey, qualifierValue) {
      this.qualifiers.get(qualifierKey).addValue(qualifierValue);
      return this;
    }
  }]);

  return Action;
}(ActionModel);

export { Action };